/**
 * Purpose: read a `contactUpdated` event the same way every contact store
 * can. Profile edits emit that event from the root `updateContact` action
 * after PUT /api/contacts/:id. The body is bucket-keyed, for example
 * { "1520": { office: "<record id>", first_name: "Ada" } }.
 *
 * Dragging a board card does not emit this event. It saves through the
 * column store. Subscribers should ignore a contact they are already saving.
 *
 * @see src/store/modules/contacts/actions.js
 * @see src/views/contacts/relationships/ContactsRelationships.vue
 * @see src/views/contacts/boards/ContactsBoardColumn.vue
 * @see src/views/contacts/contactUpdate.spec.js
 */

export const CONTACT_NAME_FIELDS = ['first_name', 'last_name'];

/**
 * Field values from a contactUpdated payload.
 * Profile saves nest fields under a bucket id. Each bucket object is merged.
 * A non-object payload yields an empty map.
 */
export function fieldsFromContactUpdate(params) {
  if (!params || typeof params !== 'object' || Array.isArray(params)) {
    return {};
  }

  const fields = {};
  Object.values(params).forEach((bucket) => {
    if (!bucket || typeof bucket !== 'object' || Array.isArray(bucket)) {
      return;
    }
    Object.assign(fields, bucket);
  });
  return fields;
}

/**
 * first_name / last_name entries present on the update, including clears.
 */
export function nameFieldsFromContactUpdate(params) {
  const fields = fieldsFromContactUpdate(params);
  const patch = {};
  CONTACT_NAME_FIELDS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(fields, key)) {
      patch[key] = fields[key];
    }
  });
  return patch;
}
